export default __webpack_public_path__ + "static/media/img-adolescent.93a27b5e.svg";